import { IGetLabelParams } from './ProductOptions.types'

export const getLabelForOption = ({
  name,
  useCounter,
  multiplierMark = '',
  minQtyPerSku = 0,
  suffixLabel = ''
}: IGetLabelParams): string => {
  const prefix =
    minQtyPerSku > 1 && !useCounter ? `${minQtyPerSku}${multiplierMark} ` : ''
  const suffix = suffixLabel ? ` - ${suffixLabel}` : ''

  return `${prefix}${name}${suffix}`
}
